<template>
  <SelectV2
    class="selectV2"
    :allow-create="allowCreate"
    :value="formValue"
    value-key="id"
    v-bind="$attrs"
    v-on="changeListeners"
    filterable
    :multiple="isMultiple"
    clearable
    remote
    :loading="loading"
    :remote-method="setKeyWord"
    popper-class="remoteSelect"
    :placeholder="placeholder"
    :collapse-tags="isCollapse"
    :disabled="isDisable"
    v-loadmore="loadMore"
    loadingText="ロード中"
    noMatchText="データなし"
    noDataText="データなし"
  >
    <el-option
      disabled
      value="-1"
      class="disable"
      v-if="displayList.length > 0 && isSelectAllFunc"
    >
      <el-row class="select-handle" :style="{ fontSize: isSetFontSize ? '14px' : '16px' }" type="flex">
        <el-col :span="isSetFontSize ? 12 : 6">
          <div @click="selectHandler('select')" class="action">
            <a class="el-icon-check"></a>
            {{ $locale("global.selectAll") }}
          </div>
        </el-col>
        <el-col :span="isSetFontSize ? 12 : 6">
          <div @click="selectHandler('empty')" class="action">
            <a class="el-icon-close"></a>
            {{ $locale("global.deselectAll") }}
          </div>
        </el-col>
      </el-row>
    </el-option>
    <el-option value="all" label="すべてのバージョン" v-if="useType === 'all'"></el-option>
    <el-option
      v-for="item in (isAppendCinemaName ?
      displayList.map((item) => ({
        ...item,
        name: `${item.name}${getFormatCinemaName(item)}`
      })) :
      displayList)"
      :key="item.id || item.name"
      :label="item.name"
      :value="isObjectItem ? item : (item.id || item.name)"
      :disabled="isDisabledWhenAllSelected"
    ></el-option>
  </SelectV2>
</template>
<script>
import SelectV2 from "@/components/common/Select-v2/index.js";
import { getClientListService, getCinemaListMap, getSimpleMovieList, getMovieStaff } from "@/helpers/service/api/common";
import { getAccountReceivableListMap } from "@/helpers/service/api/accountPayable";
import { getCouponTypeListForSelect } from "@/helpers/service/api/coupon";
import { getMovieGenreListMapService, getMovieAreaListMapService } from "@/helpers/service/api/movie.js";

import axios from "@/helpers/service/axiosPlugin";
import locale from "@/helpers/locale";
import axiosInstance from "axios";

const { CancelToken } = axiosInstance;
let cancel = null;

export default {
  data() {
    return {
      page: 1,
      keyWord: "",
      loading: false,
      searchTimer: null,
      localList: [], // 内部维护的搜索列表，不会影响父组件的 list
    };
  },
  methods: {
    setKeyWord(query) {
      // Element-UI Select(remote+filterable+multiple) will call remoteMethod("")
      // right after selecting an option (because it clears query).
      // That empty query should NOT trigger another API request.
      if (query === this.keyWord) {
        return;
      }

      this.keyWord = query;
      this.page = 0;

      if (!query) {
        // 清空搜索关键词时，不清空 localList，保留之前的搜索结果
        // 这样选中后不会还原到父组件的 list
        this.loading = false;
        return;
      }

      // 搜索新关键词时，先清空之前的搜索结果
      this.localList = [];
      this.delaySearch();
    },
    loadMore() {
      if (this.type === "client") {
        getClientListService({
          page: this.page,
          pageSize: 20,
          name: this.keyWord,
          field: this.fields
        }).then(res => {
          if (res.data.data.length > 0) {
            this.page++;
          }
          let _arr = [];
          if (this.localList.length === 0) {
            _arr = this.selectedList.concat(this.list).concat(this.localList).concat(res.data.data);
          } else {
            _arr = this.selectedList.concat(this.localList).concat(res.data.data);
          }
          _arr = this.$_.uniqBy(_arr, "id");
          this.localList = _arr;
          // 如果父组件监听了 setList 事件，触发它（可选，用于兼容）
          if (this.$listeners.setList) {
            this.$emit("setList", _arr);
          }
          this.loading = false;
        });
      } else if(this.type === "invoice") {
        getAccountReceivableListMap({
          page: this.page,
          pageSize: 20,
          ...this.keyWord ? { name: this.keyWord } : {},
          field: this.fields
        }).then(res => {
          if (res.data.data.length > 0) {
            this.page++;
          }
          let _arr = [];
          if (this.localList.length === 0) {
            _arr = this.selectedList.concat(this.list).concat(this.localList).concat(res.data.data);
          } else {
            _arr = this.selectedList.concat(this.localList).concat(res.data.data);
          }
          _arr = this.$_.uniqBy(_arr, "id");
          this.localList = _arr;
          // 如果父组件监听了 setList 事件，触发它（可选，用于兼容）
          if (this.$listeners.setList) {
            this.$emit("setList", _arr);
          }
          this.loading = false;
        });
      } else if (this.type === "coupon") {
        getCouponTypeListForSelect({
          cinemaId: window.localStorage.getItem("cinemaId"),
          page: this.page,
          pageSize: 20,
          ...this.keyWord ? { name: this.keyWord } : {},
          field: this.fields
        }).then(res => {
          if (res.data.data.length > 0) {
            this.page++;
          }
          let _arr = [];
          if (this.localList.length === 0) {
            _arr = this.selectedList.concat(this.list).concat(this.localList).concat(res.data.data);
          } else {
            _arr = this.selectedList.concat(this.localList).concat(res.data.data);
          }
          _arr = this.$_.uniqBy(_arr, "id");
          this.localList = _arr;
          // 如果父组件监听了 setList 事件，触发它（可选，用于兼容）
          if (this.$listeners.setList) {
            this.$emit("setList", _arr);
          }
          this.loading = false;
        });
      } else if (this.type === "cinema") {
        getCinemaListMap({
          page: this.page,
          pageSize: 20,
          ...this.keyWord ? { name: this.keyWord } : {},
          status: "active",
          field: this.fields
        }, false).then(res => {
          if (res.data.data.length > 0) {
            this.page++;
          }
          let _arr = [];
          if (this.localList.length === 0) {
            _arr = this.selectedList.concat(this.list).concat(this.localList).concat(res.data.data);
          } else {
            _arr = this.selectedList.concat(this.localList).concat(res.data.data);
          }
          _arr = this.$_.uniqBy(_arr, "id");
          this.localList = _arr;
          // 如果父组件监听了 setList 事件，触发它（可选，用于兼容）
          if (this.$listeners.setList) {
            this.$emit("setList", _arr);
          }
          this.loading = false;
        });
      } else if (this.type === "filmForSearch") {
        getSimpleMovieList({
          status: "active",
          approve: true,
          page: this.page,
          pageSize: 20,
          hiddenCms: false,
          ...this.keyWord ? { name: this.keyWord } : {},
          ...this.isAppendCinemaName ? {
            brandId: window.localStorage.getItem("brandId"),
          } : {
            cinemaId: window.localStorage.getItem("cinemaId"),
          },
          field: this.fields
        }, false).then(res => {
          if (res.data && res.data.data.length > 0) {
            this.page++;
          }
          let _arr = [];
          if (this.localList.length === 0) {
            _arr = this.selectedList.concat(this.list).concat(this.localList).concat(res.data.data);
          } else {
            _arr = this.selectedList.concat(this.localList).concat(res.data.data);
          }
          _arr = this.$_.uniqBy(_arr, "id");
          this.localList = _arr;
          // 如果父组件监听了 setList 事件，触发它（可选，用于兼容）
          if (this.$listeners.setList) {
            this.$emit("setList", _arr);
          }
          this.loading = false;
        });
      } else if (this.type === "actor") {
        getMovieStaff({
          role: "actor",
          page: this.page,
          pageSize: 20,
          name: this.keyWord,
          field: this.fields,
        }, false).then(res => {
          if (res.data.data.length > 0) {
            this.page++;
          }
          const _arrs = res.data.data.filter(item => item.roles.indexOf("actor") > -1);
          let _arr = [];
          if (this.localList.length === 0) {
            _arr = this.selectedList.concat(this.list).concat(this.localList).concat(_arrs);
          } else {
            _arr = this.selectedList.concat(this.localList).concat(_arrs);
          }
          _arr = this.$_.uniqBy(_arr, "id");
          this.localList = _arr;
          // 如果父组件监听了 setList 事件，触发它（可选，用于兼容）
          if (this.$listeners.setList) {
            this.$emit("setList", _arr);
          }
          this.loading = false;
        });
      } else if (this.type === "director") {
        getMovieStaff({
          role: "director",
          page: this.page,
          pageSize: 20,
          name: this.keyWord,
          field: this.fields,
        }, false).then(res => {
          if (res.data.data.length > 0) {
            this.page++;
          }
          const _arrs = res.data.data.filter(item => item.roles.indexOf("director") > -1);
          let _arr = [];
          if (this.localList.length === 0) {
            _arr = this.selectedList.concat(this.list).concat(this.localList).concat(_arrs);
          } else {
            _arr = this.selectedList.concat(this.localList).concat(_arrs);
          }
          _arr = this.$_.uniqBy(_arr, "id");
          this.localList = _arr;
          // 如果父组件监听了 setList 事件，触发它（可选，用于兼容）
          if (this.$listeners.setList) {
            this.$emit("setList", _arr);
          }
          this.loading = false;
        });
      } else if (this.type === "writers") {
        getMovieStaff({
          role: "writer",
          page: this.page,
          pageSize: 20,
          name: this.keyWord,
          field: this.fields,
        }, false).then(res => {
          if (res.data.data.length > 0) {
            this.page++;
          }
          const _arrs = res.data.data.filter(item => item.roles.indexOf("writer") > -1);
          let _arr = [];
          if (this.localList.length === 0) {
            _arr = this.selectedList.concat(this.list).concat(this.localList).concat(_arrs);
          } else {
            _arr = this.selectedList.concat(this.localList).concat(_arrs);
          }
          _arr = this.$_.uniqBy(_arr, "id");
          this.localList = _arr;
          // 如果父组件监听了 setList 事件，触发它（可选，用于兼容）
          if (this.$listeners.setList) {
            this.$emit("setList", _arr);
          }
          this.loading = false;
        });
      } else if (this.type === "genres") {
        getMovieGenreListMapService({
          field: this.fields,
          page: this.page,
          pageSize: 20,
          ...this.keyWord ? { name: this.keyWord } : {},
        }, false).then(res => {
          if (res.data.data.length > 0) {
            this.page++;
          }
          const _arrs = res.data.data;
          let _arr = [];
          if (this.localList.length === 0) {
            _arr = this.selectedList.concat(this.list).concat(this.localList).concat(_arrs);
          } else {
            _arr = this.selectedList.concat(this.localList).concat(_arrs);
          }
          _arr = this.$_.uniqBy(_arr, "id");
          this.localList = _arr;
          // 如果父组件监听了 setList 事件，触发它（可选，用于兼容）
          if (this.$listeners.setList) {
            this.$emit("setList", _arr);
          }
          this.loading = false;
        });
      } else if (this.type === "areas") {
        getMovieAreaListMapService({
          field: this.fields,
          page: this.page,
          pageSize: 20,
          ...this.keyWord ? { name: this.keyWord } : {},
        }, false).then(res => {
          if (res.data.data.length > 0) {
            this.page++;
          }
          const _arrs = res.data.data;
          let _arr = [];
          if (this.localList.length === 0) {
            _arr = this.selectedList.concat(this.list).concat(this.localList).concat(_arrs);
          } else {
            _arr = this.selectedList.concat(this.localList).concat(_arrs);
          }
          _arr = this.$_.uniqBy(_arr, "id");
          this.localList = _arr;
          // 如果父组件监听了 setList 事件，触发它（可选，用于兼容）
          if (this.$listeners.setList) {
            this.$emit("setList", _arr);
          }
          this.loading = false;
        });
      }
    },
    selectHandler(act) {
      let arr = [];
      if (act === "select" && this.useType === "all") {
        arr.push("all");
      } else if (act === "select") {
        this.displayList.map(item => {
          arr.push(item.id);
        });
      }
      this.$emit("selectAll", arr);
    },
    delaySearch() {
      if (cancel !== null) {
        cancel();
      }
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(() => {
        this.loading = true;
        if (this.type === "client") {
          getClientListService({
            page: 0,
            pageSize: 20,
            name: this.keyWord,
            field: this.fields,
          }).then(res => {
            if (res.data.data.length > 0) {
              this.page++;
            }
            let _arr = this.selectedList.concat(res.data.data);
            _arr = this.$_.uniqBy(_arr, "id");
            this.localList = _arr;
            // 如果父组件监听了 setList 事件，触发它（可选，用于兼容）
            if (this.$listeners.setList) {
              this.$emit("setList", _arr);
            }
            this.loading = false;
          });
        } else if (this.type === "movie") {
          axios({
            url: "/api/film/eglSearchByName",
            method: "get",
            data: {
              data: {
                name: this.keyWord,
              },
              loading: false,
              isDefaultAlertTips: false
            },
            cancelToken: new CancelToken(function executor(c) {
              cancel = c;
            }),
          }).then(res => {
            cancel = null;
            let _arr = res.data;
            if (this.isForCP2 && res.data.length === 0) {
              _arr.push({
                id: "",
                name: `${this.keyWord} を新規作成する`
              });
            }
            this.localList = _arr;
            // 如果父组件监听了 setList 事件，触发它（可选，用于兼容）
            if (this.$listeners.setList) {
              this.$emit("setList", _arr);
            }
            this.loading = false;
          });
        } else if (this.type === "coupon") {
          getCouponTypeListForSelect({
            cinemaId: window.localStorage.getItem("cinemaId"),
            page: this.page,
            pageSize: 20,
            ...this.keyWord ? { name: this.keyWord } : {},
            field: this.fields
          }).then(res => {
            if (res.data.data.length > 0) {
              this.page++;
            }
            let _arr = this.selectedList.concat(res.data.data);
            _arr = this.$_.uniqBy(_arr, "id");
            this.localList = _arr;
            // 如果父组件监听了 setList 事件，触发它（可选，用于兼容）
            if (this.$listeners.setList) {
              this.$emit("setList", _arr);
            }
            this.loading = false;
          });
        } else if (this.type === "cinema") {
          getCinemaListMap({
            page: this.page,
            pageSize: 20,
            ...this.keyWord ? { name: this.keyWord } : {},
            status: "active",
            field: this.fields
          }, false).then(res => {
            if (res.data.data.length > 0) {
              this.page++;
            }
            let _arr = this.selectedList.concat(res.data.data);
            _arr = this.$_.uniqBy(_arr, "id");
            this.localList = _arr;
            // 如果父组件监听了 setList 事件，触发它（可选，用于兼容）
            if (this.$listeners.setList) {
              this.$emit("setList", _arr);
            }
            this.loading = false;
          });
        } else if (this.type === "filmForSearch") {
          getSimpleMovieList({
            status: "active",
            approve: true,
            page: this.page,
            pageSize: 20,
            hiddenCms: false,
            ...this.keyWord ? { name: this.keyWord } : {},
            cinemaId: window.localStorage.getItem("cinemaId"),
            field: this.fields
          }, false).then(res => {
            if (res.data && res.data.data.length > 0) {
              this.page++;
            }
            let _arr = this.selectedList.concat(res.data.data);
            _arr = this.$_.uniqBy(_arr, "id");
            this.localList = _arr;
            // 如果父组件监听了 setList 事件，触发它（可选，用于兼容）
            if (this.$listeners.setList) {
              this.$emit("setList", _arr);
            }
            this.loading = false;
          });
        } else if (this.type === "actor") {
          getMovieStaff({
            role: "actor",
            page: this.page,
            pageSize: 20,
            ...this.keyWord ? { name: this.keyWord } : {},
            field: this.fields,
          }, false).then(res => {
            if (res.data.data.length > 0) {
              this.page++;
            }
            const _arrs = res.data.data.filter(item => item.roles.indexOf("actor") > -1);
            let _arr = this.selectedList.concat(_arrs);
            _arr = this.$_.uniqBy(_arr, "id");
            this.localList = _arr;
            // 如果父组件监听了 setList 事件，触发它（可选，用于兼容）
            if (this.$listeners.setList) {
              this.$emit("setList", _arr);
            }
            this.loading = false;
          });
        } else if (this.type === "director") {
          getMovieStaff({
            role: "director",
            page: this.page,
            pageSize: 20,
            ...this.keyWord ? { name: this.keyWord } : {},
            field: this.fields,
          }, false).then(res => {
            if (res.data.data.length > 0) {
              this.page++;
            }
            const _arrs = res.data.data.filter(item => item.roles.indexOf("director") > -1);
            let _arr = this.selectedList.concat(_arrs);
            _arr = this.$_.uniqBy(_arr, "id");
            this.localList = _arr;
            // 如果父组件监听了 setList 事件，触发它（可选，用于兼容）
            if (this.$listeners.setList) {
              this.$emit("setList", _arr);
            }
            this.loading = false;
          });
        } else if (this.type === "writers") {
          getMovieStaff({
            role: "writer",
            page: this.page,
            pageSize: 20,
            ...this.keyWord ? { name: this.keyWord } : {},
            field: this.fields,
          }, false).then(res => {
            if (res.data.data.length > 0) {
              this.page++;
            }
            const _arrs = res.data.data.filter(item => item.roles.indexOf("writer") > -1);
            let _arr = this.selectedList.concat(_arrs);
            _arr = this.$_.uniqBy(_arr, "id");
            this.localList = _arr;
            // 如果父组件监听了 setList 事件，触发它（可选，用于兼容）
            if (this.$listeners.setList) {
              this.$emit("setList", _arr);
            }
            this.loading = false;
          });
        } else if (this.type === "genres") {
          getMovieGenreListMapService({
            page: this.page,
            pageSize: 20,
            ...this.keyWord ? { name: this.keyWord } : {},
            field: this.fields,
          }, false).then(res => {
            if (res.data.data.length > 0) {
              this.page++;
            }
            const _arrs = res.data.data;
            let _arr = this.selectedList.concat(_arrs);
            _arr = this.$_.uniqBy(_arr, "id");
            this.localList = _arr;
            // 如果父组件监听了 setList 事件，触发它（可选，用于兼容）
            if (this.$listeners.setList) {
              this.$emit("setList", _arr);
            }
            this.loading = false;
          });
        } else if (this.type === "areas") {
          getMovieAreaListMapService({
            page: this.page,
            pageSize: 20,
            ...this.keyWord ? { name: this.keyWord } : {},
            field: this.fields,
          }, false).then(res => {
            if (res.data.data.length > 0) {
              this.page++;
            }
            const _arrs = res.data.data;
            let _arr = this.selectedList.concat(_arrs);
            _arr = this.$_.uniqBy(_arr, "id");
            this.localList = _arr;
            // 如果父组件监听了 setList 事件，触发它（可选，用于兼容）
            if (this.$listeners.setList) {
              this.$emit("setList", _arr);
            }
            this.loading = false;
          });
        }
      }, 300);
    },
    getFormatCinemaName(obj) {
      const cinemaObj = this.cinemaList.find(item => item.id === obj.cinemaId);
      return cinemaObj ? `[${(cinemaObj || {}).name}]` : "";
    }
  },
  beforeDestroy() {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
      this.searchTimer = null;
    }
    if (cancel !== null) {
      cancel();
      cancel = null;
    }
  },
  props: {
    type: {
      type: String,
      default: "client"
    },
    list: {
      type: Array,
      default: () => []
    },
    formValue: {
      type: [Array, String]
    },
    isSelectAllFunc: {
      type: Boolean,
      default: false
    },
    isMultiple: {
      type: Boolean,
      default: true
    },
    isCollapse: {
      type: Boolean,
      default: false
    },
    isDisable: {
      type: Boolean,
      default: false
    },
    fields: {
      type: Array,
      default: () => ["id", "name"]
    },
    isForCP2: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: () => locale("global.search.tips")
    },
    allowCreate: {
      type: Boolean,
      default: false
    },
    isObjectItem: {
      type: Boolean,
      default: false,
    },
    cinemaList: {
      type: Array,
      default: () => [],
    },
    isAppendCinemaName: {
      type: Boolean,
      default: false,
    },
    useType: {
      type: String,
      default: "",
    },
    isSetFontSize: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selectedList() {
      // 从父组件的 list 和 localList 中查找已选中的项
      // 避免循环依赖 displayList
      let _arr = [];
      if (this.isMultiple && Array.isArray(this.formValue) && this.formValue.length > 0) {
        const allItems = [...this.list, ...this.localList];
        this.formValue.forEach(id => {
          const itemId = typeof id !== "object" ? id : id.id;
          const found = allItems.find(item => item.id === itemId);
          if (found) {
            _arr.push(found);
          }
        });
      }
      return _arr;
    },
    // 合并父组件传入的 list 和内部搜索的 localList
    displayList() {
      if (this.localList.length > 0) {
        return this.localList;
      }
      return this.list;
    },
    isDisabledWhenAllSelected() {
      // 当 formValue 等于 "all" 或包含 "all" 时，禁用其他选项
      if (this.useType === "all") {
        if (this.isMultiple) {
          // 多选模式：检查数组是否包含 "all"
          return Array.isArray(this.formValue) && this.formValue.includes("all");
        }
        // 单选模式：检查值是否等于 "all"
        return this.formValue === "all";
      }
      return false;
    },
    changeListeners() {
      const vm = this;
      return Object.assign({}, this.$listeners, {
        change: function(_value) {
          vm.$emit("change", _value);
        },
      });
    },
  },
  components: {
    SelectV2
  }
};
</script>
